import { useCallback, useEffect, useState } from 'react'
import { getUserInfoApi } from '@/api/user'
import { useAuthStore } from '@/stores/authStore'
import { parseUserSetting } from '@/utils/userSetting'

export function usePersonalSettings() {
  const { user, updateUser } = useAuthStore()
  const [loading, setLoading] = useState(false)

  const refreshProfile = useCallback(async () => {
    setLoading(true)
    try {
      const profile = await getUserInfoApi()
      updateUser(profile)
      return profile
    } finally {
      setLoading(false)
    }
  }, [updateUser])

  useEffect(() => {
    void refreshProfile()
  }, [refreshProfile])

  const setting = parseUserSetting(user?.setting)

  return {
    user,
    setting,
    loading,
    refreshProfile,
    parseUserSetting,
  }
}
